/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from '../../../api/api';
import { getTokenData } from 'src/utils/api';
import { LOADING_STATUSES } from '../../../constants/statuses';
import { isResponseSuccess, formatFilters } from '../../../utils/api';
import { INITIAL_FILTERS_STATE } from '../constants/domains';

export const loadDomains = createAsyncThunk(
  'domains/loadDomains',
  async (data, {
    getState,
    rejectWithValue,
  }) => {
    try {
      const { filters, page, per } = getState().domainsReducer;
      const formattedFilters = formatFilters(filters);
      const response = await API(getTokenData()).DOMAINS.load({
        ...formattedFilters,
        page: page + 1,
        per,
      });
      if (isResponseSuccess(response.status)) {
        return {
          data: response.data,
          totalItems: response.total,
        };
      }
      return {};
    } catch (error) {
      return rejectWithValue(error.toString);
    }
  },
);

const initialState = {
  entity: [],
  page: 0,
  per: 100,
  totalItems: 0,
  filters: INITIAL_FILTERS_STATE,
  status: LOADING_STATUSES.IDLE,
  error: null,
};

const domainsSlice = createSlice({
  name: 'domains',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
    setPageData: (state, action) => {
      state.page = action.payload.page;
      state.per = action.payload.per;
    },
    resetDomains: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadDomains.pending, (state) => {
        state.status = LOADING_STATUSES.LOADING;
      })
      .addCase(loadDomains.fulfilled, (state, action) => {
        state.entity = action.payload?.data || [];
        state.totalItems = action.payload?.totalItems || 0;
        state.status = LOADING_STATUSES.SUCCEEDED;
      })
      .addCase(loadDomains.rejected, (state) => {
        state.status = LOADING_STATUSES.FAILED;
      });
  },
});

export const {
  setFilters,
  setPageData,
  resetDomains,
} = domainsSlice.actions;
export default domainsSlice.reducer;

export const domainsFilterApply = createAsyncThunk(
  'domains/filterApply',
  async (newFilters, {
    dispatch,
    rejectWithValue,
  }) => {
    try {
      await dispatch(setFilters({
        ...newFilters,
      }));
      await dispatch(loadDomains());
      return {};
    } catch (error) {
      return rejectWithValue(error.toString);
    }
  },
);

export const domainsChangePageAction = createAsyncThunk(
  'domains/domainsChangePageAction',
  async ({
    page = 0,
    per = 0,
  }, {
    dispatch,
    rejectWithValue,
  }) => {
    try {
      await dispatch(setPageData({
        page,
        per,
      }));
      await dispatch(loadDomains());
      return {};
    } catch (error) {
      return rejectWithValue(error.toString);
    }
  },
);
